interface CommissionTableProps {
  discountPercentage: string;
  commissionRate: string;
}

export function CommissionTable({
  discountPercentage,
  commissionRate,
}: CommissionTableProps) {
  // Fixed product price (matching CheckoutPreview)
  const productPrice = 785.95;
  const subtotal = productPrice;

  // Calculate values
  const discountPercent = parseFloat(discountPercentage) || 0;
  const commissionPercent = parseFloat(commissionRate) || 0;
  const discountAmount = (subtotal * discountPercent) / 100;
  const discountedTotal = subtotal - discountAmount;
  const commissionValue = (discountedTotal * commissionPercent) / 100;

  // Generate discount code
  const discountCode = `SAVE${Math.round(discountPercent)}`;

  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  // Sample data for preview
  const affiliateName = "John Doe";

  return (
    <div className="bg-card rounded-lg border border-border p-4 w-full max-w-4xl overflow-x-auto">
      <table className="w-full min-w-[28rem]">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-2 px-3 text-sm font-semibold text-muted-foreground">
              Affiliate Name
            </th>
            <th className="text-left py-2 px-3 text-sm font-semibold text-muted-foreground">
              Discount Code
            </th>
            <th className="text-left py-2 px-3 text-sm font-semibold text-muted-foreground">
              Commission Value
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="py-3 px-3 text-sm text-foreground font-medium">
              {affiliateName}
            </td>
            <td className="py-3 px-3">
              <span className="text-sm text-foreground font-medium">
                {discountCode}
              </span>
            </td>
            <td className="py-3 px-3 text-sm text-foreground font-semibold">
              {formatCurrency(commissionValue)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
